import axios from 'axios';
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.agent;
const settingsUrl = endpointNames.settings;
const apiBaseUrl = endpointNames.base;


//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//get all agents
const getAllAgents = async () => {
    let response;
    // start
    //create configuration with token
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    //include the config in your request
    await axios.get(baseUrl + 's', config)
        .then(res => {
            console.log("agents: ", res);
            if (res.status === 200) {
                response = res.data;
            } else {
                response = []
            }

        })
        .catch(err => {
            console.log(err);
            response = [];
        });

    // end

    return response;
}

//get agent details
const getAgentDetails = async (id) => {
    let response;
    await axios.get(baseUrl + '/' + id, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
        });
    return response;
}


//get agent accident clients
const getAgentClients = async (id) => {
    let response;
    await axios.get(apiBaseUrl + '/policy-holders/' + id, {
        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log("acc: ", res);
            response = res.data;
        }).catch(err => {
            console.log(err);
            response = []
        });
    return response;
}
//get agent funeral clients
const getAgentFuneralClients = async (id) => {
    let response;
    await axios.get(baseUrl + 'get-agent/funeral/' + id)
        .then(res => {
            console.log("fun: ", res.data);
            response = res.data;
        }).catch(err => {
            console.log(err);
            response = [];
        });
    return response;
}
//get agent savings clients
const getAgentSavingsClients = async (id) => {
    let response;
    await axios.get(baseUrl + 'get-agent/savings/' + id)
        .then(res => {
            console.log("sav: ", res);
            response = res.data;
        }).catch(err => {
            console.log(err);
            response = []
        });
    return response;
}
//get agent comprehensive clients
const getAgentComprehensiveClients = async (id) => {
    let response;
    await axios.get(baseUrl + 'get-agent/comprehensive/' + id)
        .then(res => {
            console.log("com: ", res);
            response = res.data;
        }).catch(err => {
            console.log(err);
            response = []
        });
    return response;
}

//add agent
const addAgent = async (request) => {
    let response;
    console.log('request: ', request);
    await axios.post(baseUrl, request, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//update agent details
const updateAgent = async (request) => {
    let response;
    console.log("request: ", request)
    await axios.put(baseUrl + '/update/' + request.agentId, request, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get all Channels
const getAllChannels = async () => {
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(settingsUrl.getChannels, config)
        .then(res => {
            console.log(res.data);
            response = res.data;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get all Channels
const getAllPositions = async () => {
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(settingsUrl.getPositions, config)
        .then(res => {
            console.log(res.data);
            response = res.data;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get all Channels
const getAllTeams = async () => {
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(settingsUrl.getTeams, config)
        .then(res => {
            console.log(res.data);
            response = res.data;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


//delete agent
const deleteAgent = async (id) => {
    let response;
    await axios.delete(baseUrl + "delete-agent/" + id)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

async function activate(id) {

    console.log("id: ", id)
    try {
        const response = await axios.post(baseUrl + '/activate/' + id, {}, {
            headers: {Authorization: `Bearer ${token}`},
        })
        console.log("response:", response);
        return response.data;
    } catch (e) {
        console.log(e);
        return 0;
    }
}

async function deactivate(id) {
    console.log("id: ", id)

    console.log("id: ", id)
    try {
        const response = await axios.post(baseUrl + '/de-activate/' + id, {}, {
            headers: {Authorization: `Bearer ${token}`},
        })
        console.log("response:", response);
        return response.data;
    } catch (e) {
        console.log(e);
        return 0;
    }
}

export default {
    getAllAgents,
    getAgentDetails,
    addAgent,
    updateAgent,
    deleteAgent,
    getAgentComprehensiveClients,
    getAgentClients,
    getAgentFuneralClients,
    getAgentSavingsClients,
    getAllChannels,
    getAllPositions,
    getAllTeams,
    deactivate,
    activate
}
